import {
    Flex,
    Label,
    FormNote,
    Select,
} from '@bamboohr/fabric';

/**
 * Props for the LocationSelect component
 */
export type LocationSelectProps = {
    locations: {
        byId: {[id: string]: { displayText: string; val: string; }};
        allIds: string[];
    };
    newHirePacket: boolean;
    selectedLocation?: string;
    showLocationRequiredAsterisk: boolean;
    stateAbbr: string | null;
    viewOnly: boolean;
    onLocationChange: (selectedValues: string[]) => void;
};

/**
 * LocationSelect Component
 * 
 * A component that renders a select dropdown for choosing a location
 * for state tax withholding.
 */
export const LocationSelect = ({
    locations,
    newHirePacket,
    selectedLocation,
    showLocationRequiredAsterisk,
    stateAbbr,
    viewOnly,
    onLocationChange,
}: LocationSelectProps) => {
    return (
        <Flex flexDirection="column">
            <Label 
                disabled={ viewOnly || newHirePacket } 
                htmlFor="stateLocation" 
                required={ showLocationRequiredAsterisk }
            >
                { $.__('Location') }
            </Label>
            <Flex alignItems="center" gap={1}>
                <Select
                    id="stateLocation"
                    isClearable={ true }
                    isDisabled={ viewOnly || newHirePacket }
                    items={
                        locations.allIds.map((location) => {
                            return {
                                text: locations.byId[location].displayText,
                                value: locations.byId[location].val,
                            };
                        })
                    }
                    name="state[location]"
                    onChange={ onLocationChange }
                    required={ showLocationRequiredAsterisk }
                    selectedValues={ [selectedLocation] }
                    width={ 5 }
                />
                { stateAbbr && (
                    <FormNote>{ $.__('State: %1$s', stateAbbr) }</FormNote>
                ) }
            </Flex>
        </Flex>
    );
};